module.exports = __webpack_public_path__ + "img/contact.63783ccd.svg";